import {createSlotView} from '../../../components/slot';

/** Provider for a Slot View in document title */
export const TitleSlotView = createSlotView();
